import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/auth/hooks/useAuth';
import api from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

/**
 * Number of arches awaiting human review (escalated plugin reviews). Drives the
 * admin "needs review" alert that surfaces on the user menu, the Dev Console
 * dashboard, and the Plugin Review Queue. Only fetched for admins, and polled so
 * the alert clears shortly after a review is approved/rejected.
 */
export function usePendingPluginReviewCount(): number {
  const { user } = useAuth();
  const isAdmin = user?.roles?.includes('admin') ?? false;

  const { data } = useQuery({
    queryKey: queryKeys.submissions.escalatedCount(),
    queryFn: () => api.getEscalatedPluginReviewCount(),
    enabled: isAdmin,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });

  return data?.count ?? 0;
}
